import React from 'react';

export const defaultRichTextElements = {
  bold: (chunks) => <span className="bold">{chunks}</span>,
  i: (chunks) => <i>{chunks}</i>,
  span: (chunks) => <span>{chunks}</span>,
};
